import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { substringBefore3n7kj60w69hju as substringBefore } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Placeholder31b9p3m3d8sxy as Placeholder,
  ViewRenderer1i6kznnbg7y21 as ViewRenderer,
  Placeholder13jtqz2ujol8y as Placeholder_0,
  FormRendererv0cfjgipxuxv as FormRenderer,
  Companion_instance17v8p6g2424o4 as Companion_instance,
  Companion_instancegwok6qx7et5m as Companion_instance_0,
} from './FormRenderer.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  SequenceScope1coiso86pqzq2 as SequenceScope,
  sequence2vgswtrxvqoa7 as sequence,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/SequenceBuilder.mjs';
import { get_ClientModule2m5j3ywx3t162 as get_ClientModule } from '../../../../../lightning-server-shared/com/lightningkite/serialization/ClientModule.mjs';
import {
  FieldVisibility_HIDDEN_getInstancehi7nnl1vgjal as FieldVisibility_HIDDEN_getInstance,
  FieldVisibility_READ_getInstance176iysh3c9pdi as FieldVisibility_READ_getInstance,
} from './ByFieldRenderer.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mutableMapOfk2y3zt1azl40 as mutableMapOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { defaults3uorosiarf5y as defaults } from './builtinRenderers.mjs';
import {
  filter184huxd00uyfg as filter,
  sortedWith249tsu0292gn1 as sortedWith,
  mapsbvh18eqox7a as map,
  toListx6x8nvfmvvht as toList,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { first58ocm7j58k3q as first } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_atTopEnd21ub47e8cwtv6 as get_atTopEnd,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { reactive2pl1t9wy5gll5 as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_px8ok5q0jdway2 as get_px,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { SubtextSemantic_getInstance3oi0npjp97gok as SubtextSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$sequence, $completion) {
  var tmp0_safe_receiver = $this.ndw_1.pdt_1.p3(substringBefore($this.odw_1.gdu_1.az().h10(), _Char___init__impl__6a9atx(47)));
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp = $this$sequence.km(tmp0_safe_receiver, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  var tmp1_safe_receiver = $this.ndw_1.qdt_1.p3($this.odw_1.gdu_1.az().s11());
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp_0 = $this$sequence.km(tmp1_safe_receiver, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = $this.odw_1.hdu_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp0_safe_receiver_0 = $this.ndw_1.rdt_1.p3(element.j4s_1);
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp_1 = $this$sequence.km(tmp0_safe_receiver_0, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
    }
  }
  var tmp_2 = $this$sequence.km($this.ndw_1.odt_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$sequence, $completion) {
  var tmp0_safe_receiver = $this.pdw_1.tdt_1.p3(substringBefore($this.qdw_1.gdu_1.az().h10(), _Char___init__impl__6a9atx(47)));
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp = $this$sequence.km(tmp0_safe_receiver, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  var tmp1_safe_receiver = $this.pdw_1.udt_1.p3($this.qdw_1.gdu_1.az().s11());
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp_0 = $this$sequence.km(tmp1_safe_receiver, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = $this.qdw_1.hdu_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp0_safe_receiver_0 = $this.pdw_1.vdt_1.p3(element.j4s_1);
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp_1 = $this$sequence.km(tmp0_safe_receiver_0, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
    }
  }
  var tmp_2 = $this$sequence.km($this.pdw_1.sdt_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
function viewCache($this, key, generate) {
  var tmp;
  if ($this.wdt_1.q3().t1(key)) {
    var tmp_0 = $this.wdt_1.p3(key);
    tmp = (!(tmp_0 == null) ? isInterface(tmp_0, ViewRenderer()) : false) ? tmp_0 : THROW_CCE();
  } else if ($this.xdt_1.q3().t1(key)) {
    // Inline function 'kotlin.also' call
    var this_0 = ensureNotNull($this.xdt_1.p3(key));
    this_0.sdw_1 = true;
    var tmp_1 = this_0;
    tmp = isInterface(tmp_1, ViewRenderer()) ? tmp_1 : THROW_CCE();
  } else {
    var tmp0 = $this.xdt_1;
    // Inline function 'kotlin.collections.set' call
    var value = Placeholder().vdw($this, key);
    tmp0.s3(key, value);
    var result = generate();
    // Inline function 'kotlin.collections.set' call
    $this.wdt_1.s3(key, result);
    var tmp_2 = $this.xdt_1.t3(key);
    var tmp1_safe_receiver = tmp_2 instanceof Placeholder() ? tmp_2 : null;
    var tmp_3;
    if (tmp1_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp_4;
      if (tmp1_safe_receiver.sdw_1) {
        tmp1_safe_receiver.wdw(result);
        tmp_4 = tmp1_safe_receiver;
      } else {
        tmp_4 = result;
      }
      tmp_3 = tmp_4;
    }
    var tmp2_elvis_lhs = tmp_3;
    tmp = tmp2_elvis_lhs == null ? result : tmp2_elvis_lhs;
  }
  return tmp;
}
function formCache($this, key, generate) {
  var tmp;
  if ($this.ydt_1.q3().t1(key)) {
    var tmp_0 = $this.ydt_1.p3(key);
    tmp = (!(tmp_0 == null) ? isInterface(tmp_0, FormRenderer()) : false) ? tmp_0 : THROW_CCE();
  } else if ($this.zdt_1.q3().t1(key)) {
    // Inline function 'kotlin.also' call
    var this_0 = ensureNotNull($this.zdt_1.p3(key));
    this_0.ydw_1 = true;
    var tmp_1 = this_0;
    tmp = isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
  } else {
    var tmp0 = $this.zdt_1;
    // Inline function 'kotlin.collections.set' call
    var value = Placeholder_0().bdx($this, key);
    tmp0.s3(key, value);
    var result = generate();
    // Inline function 'kotlin.collections.set' call
    $this.ydt_1.s3(key, result);
    var tmp_2 = $this.zdt_1.t3(key);
    var tmp1_safe_receiver = tmp_2 instanceof Placeholder_0() ? tmp_2 : null;
    var tmp_3;
    if (tmp1_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp_4;
      if (tmp1_safe_receiver.ydw_1) {
        tmp1_safe_receiver.cdx(result);
        tmp_4 = tmp1_safe_receiver;
      } else {
        tmp_4 = result;
      }
      tmp_3 = tmp_4;
    }
    var tmp2_elvis_lhs = tmp_3;
    tmp = tmp2_elvis_lhs == null ? result : tmp2_elvis_lhs;
  }
  return tmp;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.ddx_1 = function_0;
      }
      wi(a, b) {
        return this.ddx_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.ddx_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
var sam$kotlin_Comparator$0Class_0;
function sam$kotlin_Comparator$0_0() {
  if (sam$kotlin_Comparator$0Class_0 === VOID) {
    class $ {
      constructor(function_0) {
        this.edx_1 = function_0;
      }
      wi(a, b) {
        return this.edx_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.edx_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class_0 = $;
  }
  return sam$kotlin_Comparator$0Class_0;
}
function FormModule$typeInfo$lambda(_unused_var__etf5q3) {
  println('WARN: Empty form context');
  return null;
}
var FormModule$formCandidates$slambdaClass;
function FormModule$formCandidates$slambda() {
  if (FormModule$formCandidates$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $key) {
        this.ndw_1 = this$0;
        this.odw_1 = $key;
      }
      fdx($this$sequence, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$sequence), $completion);
      }
      s2(p1, $completion) {
        return this.fdx(p1 instanceof SequenceScope() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    FormModule$formCandidates$slambdaClass = $;
  }
  return FormModule$formCandidates$slambdaClass;
}
function FormModule$formCandidates$slambda_0(this$0, $key) {
  var i = new (FormModule$formCandidates$slambda())(this$0, $key);
  var l = ($this$sequence, $completion) => i.fdx($this$sequence, $completion);
  l.$arity = 1;
  return l;
}
var FormModule$viewCandidates$slambdaClass;
function FormModule$viewCandidates$slambda() {
  if (FormModule$viewCandidates$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $key) {
        this.pdw_1 = this$0;
        this.qdw_1 = $key;
      }
      gdx($this$sequence, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$sequence), $completion);
      }
      s2(p1, $completion) {
        return this.gdx(p1 instanceof SequenceScope() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    FormModule$viewCandidates$slambdaClass = $;
  }
  return FormModule$viewCandidates$slambdaClass;
}
function FormModule$viewCandidates$slambda_0(this$0, $key) {
  var i = new (FormModule$viewCandidates$slambda())(this$0, $key);
  var l = ($this$sequence, $completion) => i.gdx($this$sequence, $completion);
  l.$arity = 1;
  return l;
}
var FormModuleClass;
function FormModule() {
  if (FormModuleClass === VOID) {
    class $ {
      constructor() {
        this.jdt_1 = get_ClientModule();
        this.kdt_1 = false;
        this.ldt_1 = null;
        var tmp = this;
        tmp.mdt_1 = FormModule$typeInfo$lambda;
        this.ndt_1 = mutableMapOf([to('com.lightningkite.lightningdb.AdminHidden', FieldVisibility_HIDDEN_getInstance()), to('com.lightningkite.lightningdb.Denormalized', FieldVisibility_READ_getInstance()), to('com.lightningkite.lightningdb.AdminViewOnly', FieldVisibility_READ_getInstance())]);
        this.odt_1 = ArrayList().w();
        this.pdt_1 = HashMap().n8();
        this.qdt_1 = HashMap().n8();
        this.rdt_1 = HashMap().n8();
        this.sdt_1 = ArrayList().w();
        this.tdt_1 = HashMap().n8();
        this.udt_1 = HashMap().n8();
        this.vdt_1 = HashMap().n8();
        this.wdt_1 = HashMap().n8();
        this.xdt_1 = HashMap().n8();
        this.ydt_1 = HashMap().n8();
        this.zdt_1 = HashMap().n8();
        defaults(this);
      }
      hdx(key) {
        return sequence(FormModule$formCandidates$slambda_0(this, key));
      }
      idx(key) {
        return sequence(FormModule$viewCandidates$slambda_0(this, key));
      }
      bdu(key) {
        return viewCache(this, key, () => {
          var tmp = this.idx(key);
          // Inline function 'kotlin.sequences.sortedByDescending' call
          var this_0 = filter(tmp, (it) => it.fdu(this, key));
          // Inline function 'kotlin.comparisons.compareByDescending' call
          var tmp_0 = (a, b) => {
            // Inline function 'kotlin.comparisons.compareValuesBy' call
            var tmp = b.tdu(this, key);
            var tmp$ret$1 = a.tdu(this, key);
            return compareValues(tmp, tmp$ret$1);
          };
          var tmp$ret$3 = new (sam$kotlin_Comparator$0())(tmp_0);
          var tmp_1 = sortedWith(this_0, tmp$ret$3);
          var options = toList(map(tmp_1, (it) => it.pdu(this, key)));
          var tmp_2;
          if (!this.kdt_1) {
            tmp_2 = first(options);
          } else {
            var tmp_3 = Companion_instance;
            var tmp_4 = first(options).p1();
            var tmp_5 = first(options).wds();
            tmp_2 = tmp_3.kdx(this, null, key, tmp_4, tmp_5, ($this$ViewRenderer, field, mutable) => {
              var selected = Signal().hak(first(options));
              // Inline function 'com.lightningkite.kiteui.views.direct.row' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view = new (RowOrCol())($this$ViewRenderer.pc());
              var tmp0_elvis_lhs = $this$ViewRenderer.ebb_1;
              var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
              $this$ViewRenderer.gbb(p, view);
              view.zbm(false);
              var tmp = get_expanding(view);
              // Inline function 'com.lightningkite.kiteui.views.direct.stack' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_0 = new (Frame())(view.pc());
              var tmp0_elvis_lhs_0 = view.ebb_1;
              var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
              view.gbb(p_0, view_0);
              var $this$stack = view_0;
              reactive($this$stack, ($this$reactive) => {
                var sel = $this$reactive.daj(selected);
                $this$stack.bba();
                return sel.vds()($this$stack, field, mutable);
              });
              view.hbb(p_0, view_0);
              view.lbb(tmp, view_0);
              var tmp_0 = view.kbb(view.kbb(sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_rem(0.75), get_rem(0.75)), view.jbb(SubtextSemantic_getInstance())), get_atTopEnd(view));
              // Inline function 'com.lightningkite.kiteui.views.direct.select' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_1 = new (Select())(view.pc());
              var tmp0_elvis_lhs_1 = view.ebb_1;
              var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
              view.gbb(p_1, view_1);
              view_1.bb9(get_px(0));
              var tmp_1 = _Constant___init__impl__v45mub(options);
              view_1.ocf(selected, new (Constant())(tmp_1), (it) => {
                var tmp0_safe_receiver = it.jdx();
                var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i20();
                var tmp = tmp1_elvis_lhs == null ? '-' : tmp1_elvis_lhs;
                var tmp2_safe_receiver = it.jdx();
                return tmp + (' (' + (tmp2_safe_receiver == null ? null : tmp2_safe_receiver.tdu(this, key)) + ', ' + it.p1().hds_1 + ' x ' + it.p1().ids_1 + ')');
              });
              view.hbb(p_1, view_1);
              view.lbb(tmp_0, view_1);
              $this$ViewRenderer.hbb(p, view);
              return view;
            });
          }
          return tmp_2;
        });
      }
      adu(key) {
        return formCache(this, key, () => {
          var tmp = this.hdx(key);
          // Inline function 'kotlin.sequences.sortedByDescending' call
          var this_0 = filter(tmp, (it) => it.fdu(this, key));
          // Inline function 'kotlin.comparisons.compareByDescending' call
          var tmp_0 = (a, b) => {
            // Inline function 'kotlin.comparisons.compareValuesBy' call
            var tmp = b.tdu(this, key);
            var tmp$ret$1 = a.tdu(this, key);
            return compareValues(tmp, tmp$ret$1);
          };
          var tmp$ret$3 = new (sam$kotlin_Comparator$0_0())(tmp_0);
          var tmp_1 = sortedWith(this_0, tmp$ret$3);
          var options = toList(map(tmp_1, (it) => it.ndu(this, key)));
          var tmp_2;
          if (!this.kdt_1) {
            tmp_2 = first(options);
          } else {
            var tmp_3 = Companion_instance_0;
            var tmp_4 = first(options).p1();
            var tmp_5 = first(options).wds();
            tmp_2 = tmp_3.ldx(this, null, key, tmp_4, tmp_5, ($this$FormRenderer, field, mutable) => {
              var selected = Signal().hak(first(options));
              // Inline function 'com.lightningkite.kiteui.views.direct.row' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view = new (RowOrCol())($this$FormRenderer.pc());
              var tmp0_elvis_lhs = $this$FormRenderer.ebb_1;
              var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
              $this$FormRenderer.gbb(p, view);
              view.zbm(false);
              var tmp = get_expanding(view);
              // Inline function 'com.lightningkite.kiteui.views.direct.stack' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_0 = new (Frame())(view.pc());
              var tmp0_elvis_lhs_0 = view.ebb_1;
              var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
              view.gbb(p_0, view_0);
              var $this$stack = view_0;
              reactive($this$stack, ($this$reactive) => {
                var sel = $this$reactive.daj(selected);
                $this$stack.bba();
                return sel.vds()($this$stack, field, mutable);
              });
              view.hbb(p_0, view_0);
              view.lbb(tmp, view_0);
              var tmp_0 = view.kbb(view.kbb(sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_rem(0.75), get_rem(0.75)), view.jbb(SubtextSemantic_getInstance())), get_atTopEnd(view));
              // Inline function 'com.lightningkite.kiteui.views.direct.select' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_1 = new (Select())(view.pc());
              var tmp0_elvis_lhs_1 = view.ebb_1;
              var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
              view.gbb(p_1, view_1);
              view_1.bb9(get_px(0));
              var tmp_1 = _Constant___init__impl__v45mub(options);
              view_1.ocf(selected, new (Constant())(tmp_1), (it) => {
                var tmp0_safe_receiver = it.jdx();
                var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i20();
                var tmp = tmp1_elvis_lhs == null ? '-' : tmp1_elvis_lhs;
                var tmp2_safe_receiver = it.jdx();
                return tmp + (' (' + (tmp2_safe_receiver == null ? null : tmp2_safe_receiver.tdu(this, key)) + ', ' + it.p1().hds_1 + ' x ' + it.p1().ids_1 + ')');
              });
              view.hbb(p_1, view_1);
              view.lbb(tmp_0, view_1);
              $this$FormRenderer.hbb(p, view);
              return view;
            });
          }
          return tmp_2;
        });
      }
      mdx(generator) {
        var tmp0_safe_receiver = generator.sdu();
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.collections.getOrPut' call
          var this_0 = this.rdt_1;
          var value = this_0.p3(tmp0_safe_receiver);
          var tmp_0;
          if (value == null) {
            var answer = ArrayList().w();
            this_0.s3(tmp0_safe_receiver, answer);
            tmp_0 = answer;
          } else {
            tmp_0 = value;
          }
          tmp = tmp_0.v(generator);
        }
        var tmp1_elvis_lhs = tmp;
        var tmp_1;
        if (tmp1_elvis_lhs == null) {
          var tmp2_safe_receiver = generator.h94();
          var tmp_2;
          if (tmp2_safe_receiver == null) {
            tmp_2 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.collections.getOrPut' call
            var this_1 = this.pdt_1;
            var value_0 = this_1.p3(tmp2_safe_receiver);
            var tmp_3;
            if (value_0 == null) {
              var answer_0 = ArrayList().w();
              this_1.s3(tmp2_safe_receiver, answer_0);
              tmp_3 = answer_0;
            } else {
              tmp_3 = value_0;
            }
            tmp_2 = tmp_3.v(generator);
          }
          tmp_1 = tmp_2;
        } else {
          tmp_1 = tmp1_elvis_lhs;
        }
        var tmp3_elvis_lhs = tmp_1;
        var tmp_4;
        if (tmp3_elvis_lhs == null) {
          var tmp4_safe_receiver = generator.s11();
          var tmp_5;
          if (tmp4_safe_receiver == null) {
            tmp_5 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.collections.getOrPut' call
            var this_2 = this.qdt_1;
            var value_1 = this_2.p3(tmp4_safe_receiver);
            var tmp_6;
            if (value_1 == null) {
              var answer_1 = ArrayList().w();
              this_2.s3(tmp4_safe_receiver, answer_1);
              tmp_6 = answer_1;
            } else {
              tmp_6 = value_1;
            }
            tmp_5 = tmp_6.v(generator);
          }
          tmp_4 = tmp_5;
        } else {
          tmp_4 = tmp3_elvis_lhs;
        }
        if (tmp_4 == null)
          this.odt_1.v(generator);
      }
      ndx(generator) {
        var tmp0_safe_receiver = generator.sdu();
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.collections.getOrPut' call
          var this_0 = this.vdt_1;
          var value = this_0.p3(tmp0_safe_receiver);
          var tmp_0;
          if (value == null) {
            var answer = ArrayList().w();
            this_0.s3(tmp0_safe_receiver, answer);
            tmp_0 = answer;
          } else {
            tmp_0 = value;
          }
          tmp = tmp_0.v(generator);
        }
        var tmp1_elvis_lhs = tmp;
        var tmp_1;
        if (tmp1_elvis_lhs == null) {
          var tmp2_safe_receiver = generator.h94();
          var tmp_2;
          if (tmp2_safe_receiver == null) {
            tmp_2 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.collections.getOrPut' call
            var this_1 = this.tdt_1;
            var value_0 = this_1.p3(tmp2_safe_receiver);
            var tmp_3;
            if (value_0 == null) {
              var answer_0 = ArrayList().w();
              this_1.s3(tmp2_safe_receiver, answer_0);
              tmp_3 = answer_0;
            } else {
              tmp_3 = value_0;
            }
            tmp_2 = tmp_3.v(generator);
          }
          tmp_1 = tmp_2;
        } else {
          tmp_1 = tmp1_elvis_lhs;
        }
        var tmp3_elvis_lhs = tmp_1;
        var tmp_4;
        if (tmp3_elvis_lhs == null) {
          var tmp4_safe_receiver = generator.s11();
          var tmp_5;
          if (tmp4_safe_receiver == null) {
            tmp_5 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.collections.getOrPut' call
            var this_2 = this.udt_1;
            var value_1 = this_2.p3(tmp4_safe_receiver);
            var tmp_6;
            if (value_1 == null) {
              var answer_1 = ArrayList().w();
              this_2.s3(tmp4_safe_receiver, answer_1);
              tmp_6 = answer_1;
            } else {
              tmp_6 = value_1;
            }
            tmp_5 = tmp_6.v(generator);
          }
          tmp_4 = tmp_5;
        } else {
          tmp_4 = tmp3_elvis_lhs;
        }
        if (tmp_4 == null)
          this.sdt_1.v(generator);
      }
    }
    initMetadataForClass($, 'FormModule', FormModule);
    FormModuleClass = $;
  }
  return FormModuleClass;
}
//region block: exports
export {
  FormModule as FormModule1vzulytb0ryex,
};
//endregion

//# sourceMappingURL=FormModule.mjs.map
